import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { ShareArticleSection } from "../ShareArticleSection";

const AmazonConnectWithAIAutomationAnalytics = () => {
  return (
    <div className="modal-content-body case-studies-blk">
      <div className="modal-section">
        <div className="flex-content header-modal-case-studies">
          <div className="logo-section-modal">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/global-payments-thumbnail-iris.png"
              alt="GlobalPay"
            />
          </div>
          <div>
            <h3>Amazon Connect with AI, Automation & Analytics</h3>
            <p>
              Unified, intelligent customer experience across leading payment
              brands - empowered by iCXeed on AWS.
            </p>
            <ShareArticleSection />
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Company Snapshot:</h2>
        <p className="title-description-blk">
          Global Payments is a global leader in payment technology and services,
          serving businesses of all sizes through innovative brands including
          eWay (online payment gateways), EziDebit (direct debit and recurring
          payments), and Sentral (education and school management solutions for
          K-12 schools).
        </p>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <div className="flex-content-half">
          <div>
            <h2 className="modal-section-title">Challenge:</h2>
            <p>
              Faced with rising customer expectations and the looming threat of
              costly Genesys licensing, Global Payments Australia needed to
              modernise and consolidate the contact centre experience across all
              three brands. Siloed voice, chat, and email channels, manual
              reporting, and a lack of actionable AI or analytics limited both
              efficiency and customer experience.
            </p>
          </div>
          <div>
            <h2 className="modal-section-title">AWS Solution:</h2>
            <p>
              Partnering with iCXeed, Global Payments migrated eWay, EziDebit,
              and Sentral to a true Amazon Connect native solution - integrating
              every channel with Salesforce Contact Centre (SCC-AC). Vertically
              integrated AI and automation now power self-service chat, voice
              optimisations, and real-time reporting. Amazon Q accelerates agent
              performance, while advanced dashboards and data lakes unlock
              cross-brand insights. Sentral benefitted from a tightly embedded
              Service Cloud Voice and chat experience, leveraging auto QA and AI
              analytics for digital and voice interactions. All brands now
              utilise a unified omnichannel platform, maintained and innovated
              through iCXeed's managed service wrap.
            </p>
          </div>
        </div>
      </div>

      <div className="outcomes-result-blk">
        <h2 className="modal-section-title">Outcomes/Results:</h2>
        <ul>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Fully optimised, unified customer experience across eWay,
                EziDebit, and Sentral, resistant to market and competitor
                threats.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Salesforce Contact Centre - Amazon Connect (SCC-AC) integration
                drives agent productivity and reduces handle time.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                AI-powered automation deflects routine contacts, improves
                first-contact resolution, and empowers agents with real-time
                assist.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Actionable, unified reporting and dashboarding provides
                leadership with instant clarity across all brands and channels.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Proactive incident, change, and data lake management ensures
                operational resilience and ongoing CX innovation.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Streamlined migration and managed service avoided Genesys
                lock-in in region, reducing risk and total cost of ownership.
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div className="modal-footnote use-cases-footnote" style={{ border: 0 }}>
        <h4>Client Testimonial</h4>
        <h1>
          "Working with iCXeed has completely transformed our business - we have
          achieved more in the last 18 months together than we did in the 5
          years prior. Our partnership has enhanced our customer experience
          through the use of analytics and automation, while also yielding
          operational efficiency gains. Arthur, Ryan & co are an integral part
          of our team; constantly going above and beyond to support our business
          goals."
        </h1>
        <div className="flex-box-blk client-details">
          <div>
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/jade-mccarthy.png"
              alt="Stefan Hutton"
            />
          </div>
          <div>
            <h2>Jade McCarthy</h2>
            <p>Head of Operations</p>
            <p>GlobalPay</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmazonConnectWithAIAutomationAnalytics;
